import React, { useState } from 'react';
import '../css/prodView.css';
import { FileEarmarkText, FileEarmarkPdf, Download, ArrowDownCircle, ArrowUpCircleFill, ArrowRight } from 'react-bootstrap-icons';

const ProdContent = ({ description, documents = [], docsDir, about = {} }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleSection = (index) => {
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    };

    const renderBenefits = () => {
        if (!Array.isArray(description) || description.length === 0) return null;

        const splitIndex = Math.ceil(description.length / 2);
        const leftColumn = description.slice(0, splitIndex);
        const rightColumn = description.slice(splitIndex);

        return (
            <div className="product-description-container">
                {description.length > 8 ? (
                    <div className="benefits-columns">
                        <ul className="bullet-list left-column">
                            {leftColumn.map((item, index) => (
                                <li key={`left-${index}`}>
                                    <ArrowRight size={14} />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                        <ul className="bullet-list right-column">
                            {rightColumn.map((item, index) => (
                                <li key={`right-${index}`}>
                                    <ArrowRight size={14} />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <ul className="bullet-list single-column-list">
                        {description.map((item, index) => (
                            <li key={index}>
                                <ArrowRight size={14} />
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    };

    const renderDocuments = () => {
        if (!Array.isArray(documents) || documents.length === 0 || !docsDir) return null;

        return (
            <div className="documents-container">
                {documents.map((doc, index) => {
                    const path = doc.doC_PATH || '';
                    const isPDF = path.toLowerCase().includes('pdf');
                    const isEXE = path.toLowerCase().includes('exe');
                    const icon = isPDF
                        ? <FileEarmarkPdf className="doc-card-icon" />
                        : <FileEarmarkText className="doc-card-icon" />;

                    const linkProps = {
                        href: `${docsDir}/${path}`,
                        className: 'docs-button',
                        ...(isEXE ? { download: true }
                            : {
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            })
                    };

                    return (
                        <a key={index} {...linkProps}>
                            <div className="doc-card-copy">
                                <span className="doc-card-type">
                                    {isEXE ? 'Download' : isPDF ? 'PDF Document' : 'Document'}
                                </span>
                                <strong className="doc-card-name">{doc.doC_NAME}</strong>
                            </div>
                            <div className="doc-card-action">
                                {isEXE ? <Download className="doc-card-icon" /> : icon}
                            </div>
                        </a>
                    );
                })}
            </div>
        );
    };

    const renderAbout = () => {
        if (!about || typeof about !== 'object' || Array.isArray(about) || Object.keys(about).length === 0) return null;

        return (
            <div className="prod-about-grid">
                {Object.entries(about).map(([header, content]) => (
                    <div key={header} className="prod-about-card">
                        <h3>{header}</h3>
                        {Array.isArray(content) ? (
                            <ul className="bullet-list single-column-list compact-list">
                                {content.map((line, index) => (
                                    <li key={index}>
                                        <ArrowRight size={14} />
                                        <span>{line}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>{content}</p>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    const sections = [
        { title: 'About the product', subtitle: 'Technical details and product context', content: renderAbout() },
        { title: 'Benefits', subtitle: 'Key advantages and selling points', content: renderBenefits() },
        { title: 'Documents', subtitle: 'Datasheets, manuals, and downloads', content: renderDocuments() }
    ];

    const visibleSections = sections.filter(section => section.content);

    if (visibleSections.length === 0) {
        return null;
    }

    return (
        <section className="prod-content-section">
            <div className="prod-content-header">
                <span className="prod-content-eyebrow">Product resources</span>
                <h2>Everything you need in one place</h2>
                <p>
                    Review product details, feature breakdowns, and related documents in a cleaner, easier-to-scan layout.
                </p>
            </div>

            <div className="prod-info-container">
                {visibleSections.map((section, index) => (
                    <div key={section.title} className={`prod-info-block ${activeIndex === index ? 'open' : ''}`}>
                        <button type="button" onClick={() => toggleSection(index)} className="prod-info-titles">
                            <div className="prod-info-title-group">
                                <span>{section.title}</span>
                                <small>{section.subtitle}</small>
                            </div>
                            <span className="icon-wrapper">
                                {activeIndex === index ? <ArrowUpCircleFill className="prod-accordion-icon active" /> : <ArrowDownCircle className="prod-accordion-icon" />}
                            </span>
                        </button>
                        <div className={`prod-info-content ${activeIndex === index ? 'open' : ''}`}>
                            {section.content}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ProdContent;
